import { AxiosError, AxiosResponse } from 'axios'
import { AppDispatch, RootState } from '../../../store'
import { Customer } from './reducer'
import { APIReferralError } from '../../../externalApps/api/errorHandlers'
import { errorLogger } from '../../../common/utils/errorLogger'
import { updateAppAlert } from '../../../common/modules/appAlert/actions'
import {
  patchCustomerDetails,
  postCustomerDetails,
} from '../../../common/api/Customers'
import { getErrorMessages } from '../../../common/utils/error'
import { RequestFailureMessage } from '../../../common/utils/messagesContants'
import { Dispatch } from 'redux'
import { addSeller, updateSeller } from '../../../cloudfaas/api/cloudfaas'

export enum NewCustomerActions {
  UPDATE_NEW_CUSTOMER_FORM = 'UPDATE_NEW_CUSTOMER_FORM',
  RESET_NEW_CUSTOMER_FORM = 'RESET_NEW_CUSTOMER_FORM',
}

export const updateNewCustomer = (data: Customer) => ({
  type: NewCustomerActions.UPDATE_NEW_CUSTOMER_FORM,
  payload: data,
})

export const resetForm = () => ({
  type: NewCustomerActions.RESET_NEW_CUSTOMER_FORM,
})

export const submitCustomerForm =
  (customer: Customer) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    try {
      const response = await postCustomerDetails(customer)
      if (customer.subscribedProducts.CLOUDFAAS) {
        const sellerData = {
          partner_id: response.data.partner_id,
          seller_email: customer?.users?.[0]?.email,
          seller_name: customer?.companyName,
        }
        await addSeller(sellerData)
      }
      await dispatch(
        updateAppAlert({
          message: 'New customer created successfully',
          messageType: 'SUCCESS',
          autoClose: true,
        })
      )
      return { success: true }
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    }
  }

export const updateCustomerForm =
  (customer: Customer, partnerId: string) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    const activeProducts =
      getState().AccountData.admin.partnerData?.activeProductsWithCloud || []
    const partnerEmail =
      getState().AccountData.admin.partnerData?.partnerOwner?.email || ''

    try {
      const updatedData = {
        companyName: customer.companyName,
        internalNotes: customer.internalNotes,
        subscribedProducts: customer.subscribedProducts,
        numberOfSeats: customer.numberOfSeats,
        isInternal: customer.isInternal,
        activeProducts: activeProducts,
        crmType: customer.crmType,
        partnershipType: customer.partnershipType,
        plan: customer.plan?.toUpperCase(),
      }
      await patchCustomerDetails(partnerId, updatedData)
      if (customer.subscribedProducts.CLOUDFAAS) {
        const sellerData = {
          partner_id: partnerId,
          seller_email: partnerEmail,
          seller_name: customer?.companyName,
        }
        await addSeller(sellerData)
      }
      await dispatch(
        updateAppAlert({
          message: 'Customer updated successfully',
          messageType: 'SUCCESS',
          autoClose: true,
        })
      )
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    }
  }
